// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1rFw5","buttons":"RemoveExpirationActionButtons_buttons__2fDs4"};